import type { ReactNode } from 'react';
import { Center, Stack, Text, Title } from '@mantine/core';
import { useAuthStore } from './auth-store';

/**
 * Renders children only when the current user's system_role is superadmin.
 * Otherwise shows a "not found" style page so the admin surface stays invisible
 * to non-superadmins (server-side gate is the real check; this is UX).
 */
export function RequireSuperadmin({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);
  if (user?.system_role === 'superadmin') return <>{children}</>;
  return (
    <Center h="60vh">
      <Stack align="center" gap="xs">
        <Title order={3}>Not found</Title>
        <Text c="dimmed">That page does not exist.</Text>
      </Stack>
    </Center>
  );
}
